<script setup lang="ts">
import { transchoice } from '@elements/translation.ts';
import Typography from '@components/Typography.vue';
import type { SelectionItem } from '@models/selectionItem.ts';
import IconInfo from '@icons/ph_icon-info.svg';
import Icon from '@components/Icon.vue';
import SelectionItemMultiOfficePanel
  from '@organisms/offer/selection-items/components/SelectionItemMultiOfficePanel.vue';
import TooltipClick from '@components/TooltipClick.vue';
import Tooltip from '@components/Tooltip.vue';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { storeToRefs } from 'pinia';

defineProps<{ selectionItem: SelectionItem }>();

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());
</script>

<template>
  <component
    :is="isMobileOrTablet ? TooltipClick : Tooltip"
    class="multioffice-tooltip"
    panel-class="multioffice-tooltip__panel"
  >
    <template #trigger>
      <span class="multioffice-tooltip__trigger">
        <Icon
          :svg="IconInfo"
          width="16"
          height="16"
          fill="gray-darker"
        />
      </span>
    </template>

    <template #panel>
      <div @click.prevent.stop>
        <Typography variant="body-small-bold">
          {{ transchoice('selection_item.tooltip.multioffice', { count: selectionItem.offers.length }) }}
        </Typography>

        <SelectionItemMultiOfficePanel :offers="selectionItem.offers" />
      </div>
    </template>
  </component>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.multioffice-tooltip {
  &__trigger {
    display: flex;
  }
}
</style>
